import NrwHeader from '~pages/nrw/layouts/NrwHeader.vue'
import NrwFooter from '~pages/nrw/layouts/NrwFooter.vue'
import NrwUiBlank from '~pages/nrw/layouts/NrwUiBlank.vue'
import NrwBottom from '~pages/nrw/layouts/NrwBottom.vue'

export default {
  header: NrwHeader,
  content: NrwUiBlank,
  footer: NrwFooter,
  bottom: NrwBottom
}



// WEBPACK FOOTER //
// ./src/components/pages/nrw/layouts/NrwDefaultLayoutComponents.js